var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.16602H9.16675",
    stroke: "#8B38FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14.5H4.16675",
    stroke: "#8B38FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17C15.5475 17 16.6667 15.8807 16.6667 14.5C16.6667 13.1193 15.5475 12 14.1667 12C12.786 12 11.6667 13.1193 11.6667 14.5C11.6667 15.8807 12.786 17 14.1667 17Z",
    stroke: "#8B38FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 8.66602C7.21396 8.66602 8.33325 7.54673 8.33325 6.16602C8.33325 4.7853 7.21396 3.66602 5.83325 3.66602C4.45254 3.66602 3.33325 4.7853 3.33325 6.16602C3.33325 7.54673 4.45254 8.66602 5.83325 8.66602Z",
    stroke: "#8B38FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconPurple);
export default __webpack_public_path__ + "static/media/settings-icon-purple.59b20a8e264f0c2af8f42bbe2758b8a7.svg";
export { ForwardRef as ReactComponent };